import { SvgIconProps } from '@material-ui/core';
import {
  createStyles,
  makeStyles,
  Theme,
  useTheme
} from '@material-ui/core/styles';
import { ChartOptions } from 'chart.js';
import { ReactElement } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    chart: {
      position: 'relative',
      height: 140,
      width: '99%',
      [theme.breakpoints.down('xs')]: {
        height: 100,
        width: 120,
        paddingRight: theme.spacing(1.5)
      }
    },
    iconChart: {
      position: 'absolute',
      [theme.breakpoints.up('sm')]: {
        top: 58,
        left: -10
      },
      [theme.breakpoints.down('xs')]: {
        top: 38,
        right: -10
      }
    }
  })
);

interface ChartStatusProps {
  labels: string[];
  quantities: number[];
  icon?: ReactElement<SvgIconProps>;
}

export default function ChartStatus({
  labels,
  quantities,
  icon
}: ChartStatusProps) {
  const classes = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();

  const options: ChartOptions<'doughnut'> = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        display: false
      }
    }
  };

  const data = {
    labels,
    datasets: [
      {
        label: t('chartStatus.documentRevision') as string,
        data: quantities,
        backgroundColor: ['#42b72abb', '#fa3c3cbb', '#ccccccbb', '#ed6c02bb'],
        borderColor: [theme.palette.background.paper],
        borderWidth: 2
      }
    ]
  };

  return (
    <div className={classes.chart}>
      <Doughnut options={options} data={data} />
      {icon && <span className={classes.iconChart}>{icon}</span>}
    </div>
  );
}
